import { unset } from 'lodash'

const abTestingPrefix = 'fe.resi.ab.testing'

// Type definitions
interface ABTest {
  test?: {
    version?: string
    [key: string]: any
  }
  [key: string]: any
}

interface FeatureFlags {
  [key: string]: ABTest | any
}

interface ABTests {
  [key: string]: ABTest
}

interface ABTestData {
  test: any
}

interface ABTestDataMap {
  [key: string]: ABTestData
}

const getABTests = (featureFlags: FeatureFlags): ABTests => {
  return Object.keys(featureFlags).reduce<ABTests>((acc, flag) => {
    if (flag.startsWith(abTestingPrefix) && featureFlags[flag]?.test) {
      acc[flag] = featureFlags[flag]
    }
    return acc
  }, {})
}

const getABTestData = (featureFlags: FeatureFlags): ABTestDataMap => {
  return Object.keys(featureFlags).reduce<ABTestDataMap>((acc, flag) => {
    if (flag.startsWith(abTestingPrefix) && featureFlags[flag]?.test) {
      const testData: ABTestData = { test: featureFlags[flag].test }
      unset(testData, 'test.version')
      acc[flag] = testData
    }
    return acc
  }, {})
}

export { getABTests, getABTestData }
export type { FeatureFlags, ABTest, ABTests, ABTestData, ABTestDataMap }
